import React from "react"

import { Alert } from "@coval/ui"

import { getCurrentDeployment } from "@/lib/local-worker-launch"
import { useDevId } from "@/hooks/useDevId"

interface LocalWorkerRoutingWarningProps {
  /**
   * Spacing that separates the warning from what surrounds it. It belongs on the
   * warning rather than on a wrapper in the caller, which would hold the gap open on
   * every surface for every user with no dev_id set.
   */
  className?: string
}

/**
 * Warns that an action is about to run on the engineer's machine.
 *
 * Renders nothing unless a dev_id is set, so every action that honors the shared
 * dev_id can mount it unconditionally instead of offering a separate button per
 * destination. Only Coval users can set one, so no flag check is needed here.
 */
export const LocalWorkerRoutingWarning: React.FC<
  LocalWorkerRoutingWarningProps
> = ({ className }) => {
  const devId = useDevId()

  if (!devId) {
    return null
  }

  return (
    <Alert variant="warning" className={className}>
      This runs on your local machine, not the {getCurrentDeployment()} fleet.
      Only the worker matching <span className="font-mono">{devId}</span> will
      claim it.
    </Alert>
  )
}
